import {welcomeBgRandomizer} from "../../blocks/pages/page-home/section-welcome/section-script";

document.addEventListener('DOMContentLoaded', function () {
    welcomeBgRandomizer();
});